// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__18m4g","clinicsSelect":"TableHeading_clinicsSelect__37FMg"};